export default __webpack_public_path__ + "static/media/rain.1e1cbe7a.svg";